export default __webpack_public_path__ + "static/media/cs1.3df7fac8.jpg";